export default __webpack_public_path__ + "static/media/Icon12_On.7420a81e.png";